<template>
  <div class="background" :class="{'long':long}">
  <div class="chart-container" :class="{'long1':long}">
    <div v-html="styleText"></div>
    <div @click="printPdf" class="noPrint">{{$t('print')}}</div>
    <div class="Hcp-main-header">
      <div class="main-header-left">
        <img src="../../assets/LOGO.png">
      </div>
      <div class="main-header-right">
        <p>{{$t('logRe')}}</p>
        <p style="font-size: 13px;">{{$t('period')}}: {{timeRange}}</p>
      </div>
    </div>
    <table class="status-table1" :class="{'zh1':!isEn}">
      <tr>
        <td class="td1 td2">{{$t('uername')}}</td><td colspan="4" class="td2">{{statics.username}}</td>
        <td class="td1 td2">{{$t('fullName')}}</td><td colspan="4" class="td3">{{statics.name}}</td>
      </tr>
      <tr>
        <td rowspan="3" class="td1 td2">{{$t('devices')}}</td>
        <td class="td2" id="reportPdmTitle">{{$t('pdm')}}</td><td colspan="8" class="td3">{{devices[0]}}</td>
      </tr>
      <tr><td class="td2">{{$t('tran')}}</td><td colspan="8" class="td3">{{devices[1]}}</td></tr>
      <tr><td class="td2">{{$t('pumpBase')}}</td><td colspan="8" class="td3">{{pump_device}}</td></tr>
      <tr>
        <td class="td1 td4">{{$t('disType')}}</td><td colspan="4" class="td4">{{statics.medical_history}}</td>
        <td class="td td4">{{$t('HbA1c')}}</td><td colspan="4">{{hb1c[0]}}</td>
      </tr>
    </table>

    <div class="small-hr"></div>
    <div class="tip" :class="{'po6':isPo,'fr6':isFr}">
      <span id="m0">{{$t('Breakfast')}}</span> <span id="m1">{{$t('Lunch')}}</span> <span id="m2">{{$t('Dinner')}}</span>
    </div>

    <div v-for="(base, p) in pagePos">
      <div v-if="p==1">

        <div class="page-seperator"></div>
        <div class="page-starter">
          <!--<br/><br/><br/><br/>-->
        </div>
      </div>

      <div class="main-wrapper table-wrapper" id="table-wrapper">
        <table class="table content">
          <tr><td style="width:60px" class="title">{{$t('date')}}</td><td style="width: 127px;border-right: none">{{$t('dailyTotal')}}</td>
            <td v-for="i in hours" class="spe7">{{i}}</td><td class="spe10">23:00</td>
          </tr>
        </table>

        <!-- ref: PER_PAGE -->
        <table class="table content" v-for="(item,index) in whichDate.slice(base, base+perPage[p])" :id="base+index"  :class="{'po4':isPo||isDu||isDe||isIt||isFr||isSw}">
          <tr>
            <td rowspan="4" style="width:60px" class="spe5">{{item}}</td>
            <td style="width: 45px" class="spe1 spe5">{{$t('BG1')}}</td>
            <td style="width: 85px" class="spe1 spe5">{{bgAvg[base+index].avg}}</td>
            <td v-for="n in 23" class="spe1 spe5"></td>  <td class="spe4 spe1"></td>
          </tr>
          <tr>
            <td class="spe">{{$t('carbs')}}</td>
            <td class="spe">{{carb[base+index].total}}</td>
            <td v-for="n in 23" class="spe"></td>  <td class="spe4 spe1"></td>
          </tr>
          <tr>
            <td class="spe">{{$t('insulin')}}</td>
            <td class="spe">{{ins[base+index].total}} {{$t('bolus')}}:{{ins[base+index].percent}} %</td>
            <td v-for="n in 23" class="spe"></td>  <td class="spe4 spe1"></td>
          </tr>
          <tr><td class="spe6">{{$t('events')}}</td><td class="spe6"></td>
            <td v-for="n in 23" class="spe6"></td>
            <td  class="spe4"></td>
          </tr>
        </table>
      </div>

    </div>

    <div v-if="chartEndPage.show">
      <div style="clear: both"></div>
      <div class="page-seperator"></div>
      <div class="page-starter">
        <!--<br/><br/><br/><br/>-->
      </div>
    </div>

    <div class="legend-group" :class="{'zh8':!isEn,'de8':isDe,'it8':isIt,'po8':isPo,'du8':isDu,'fr8':isFr||isCz,'sw8':isSw}">
      <div class="legend"><img src="../../assets/chart5-icon/High Patch.png" class="img-spe2"><span>{{$t('High Glucose')}}</span></div>
      <div class="legend"><img src="../../assets/chart5-icon/low Glucose.png" class="img-spe2"><span>{{$t('Low Glucose')}}</span></div>
      <div class="legend"><img src="../../assets/chart5-icon/middle Glucose.jpg" class="img-spe"><span>{{$t('t1112_Normal_Glucose')}}</span></div>
      <div class="legend"><img src="../../assets/chart5-icon/No Active Patch.png" class="img-spe2"><span>{{$t('No Active Patch')}}</span></div>
      <div class="legend"><img src="../../assets/chart5-icon/Manual Suspend.png" class="img-spe"><span>{{$t('manualStop')}}</span></div>
      <div class="legend"><img src="../../assets/chart5-icon/Auto Suspend.png" class="img-spe"><span>{{$t('autoStop')}}</span></div>
      <div class="legend legend-spe1" :class="{'zh9':!isEn}"><img src="../../assets/chart5-icon/Missed Meal.png" class="img-spe1"><span>{{$t('Missed Meal')}}</span></div>
      <div class="legend legend-spe2" :class="{'zh10':!isEn,'it10':isIt,'po10':isPo,'du10':isDu,'cz10':isCz}"><img src="../../assets/chart5-icon/Stop Patch .png"><span>{{$t('Stop Patch')}}</span></div>
      <div class="legend legend-spe3" :class="{'it11':isIt,'po11':isPo,'du11':isDu,'cz11':isCz}"><img src="../../assets/chart5-icon/Bolus.png" class="img-spe2"> <span>{{$t('t1112_Manual_Bolus_or_Modified_Bolus')}}</span></div>
      <div class="legend legend-spe5" :class="{'zh12':!isEn,'it11':isIt,'po12':isPo,'du12':isDu,'cz12':isCz}"><img src="../../assets/chart5-icon/New Patch .png"><span>{{$t('newPatch')}}</span></div>
      <div class="legend legend-spe6" :class="{'zh13':!isEn,'it12':isIt,'po13':isPo,'du13':isDu,'cz13':isCz}"><img src="../../assets/chart5-icon/Others.png"><span>{{$t('Others')}}</span></div>
      <div class="legend legend-spe4" :class="{'zh11':!isEn,'it13':isIt,'po14':isPo,'du14':isDu}"><img src="../../assets/chart5-icon/Exercise.png"><span>{{$t('exercise')}}</span></div>
      <div class="legend legend-spe1" :class="{'zh9':!isEn}"><img src="../../assets/chart5-icon/Mutiple Readings.png"><span>{{$t('Multiple BG Readings')}}</span></div>
      <div class="legend legend-spe7"  :class="{'zh13':!isEn,'es16':isEs}"><img src="../../assets/Hcp-icon/legend/automode/早餐.png"><span>{{$t('Breakfast')}}</span></div>
      <div class="legend legend-spe7"  :class="{'zh13':!isEn,'es16':isEs}"><img src="../../assets/Hcp-icon/legend/automode/中餐.png"><span>{{$t('Lunch')}}</span></div>
      <div class="legend legend-spe7"  :class="{'zh13':!isEn,'es16':isEs}"><img src="../../assets/Hcp-icon/legend/automode/晚餐.png"><span>{{$t('Dinner')}}</span></div>
      <div class="legend legend-spe7"  :class="{'zh13':!isEn,'es16':isEs}"><img src="../../assets/Hcp-icon/legend/automode/零食.png"><span>{{$t('Snack')}}</span></div>
      <div class="legend legend-spe7"  :class="{'zh13':!isEn,'es16':isEs}"><img src="../../assets/Hcp-icon/legend/automode/进入自动模式.png"><span>{{$t('Auto Mode On')}}</span></div>
      <div class="legend legend-spe7"  :class="{'zh13':!isEn,'es16':isEs}"><img src="../../assets/Hcp-icon/legend/automode/退出自动模式.png"><span>{{$t('Auto Mode Off')}}</span></div>

    </div>
    <div class="page-end"></div>
  </div>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
      import format from '@/lib/format'
  import B64 from '../../auth/base64'
  export default{
    data() {
      return {
        pringtPre:false,
        pump_device:'--',
        timer: false,typeChooseVisible:false, value1:'',value2:'',isC:false, flag:0,count:0, sta:'',end:'',isMg:"",ts:[],long:false,isFr:false,isSw:false,
        uid:0, st:0,et:0,autoStop:[],manualStop:[],stop:[],Newer:[],noMeal:[],mt:[],isEn:false,mt1:[],isDe:false,isEs:false,
        uid:0, st:0,et:0,autoStop:[],manualStop:[],stop:[],Newer:[],noMeal:[],mt:[],isIt:false,isPo:false,isFr:false,isCz:false,
        bgAvg:[{avg:"--",},{avg:"--",},{avg:"--",},{avg:"--",},{avg:"--",},{avg:"--",},{avg:"--",},
          {avg:"--",},{avg:"--",},{avg:"--",},{avg:"--",},{avg:"--",},{avg:"--",},{avg:"--",}],
        carb:[{total:"--",},{total:"--",},{total:"--",},{total:"--",},{total:"--",},{total:"--",},{total:"--",},{total:"--",},{total:"--",},{total:"--",},
          {total:"--",},{total:"--",},{total:"--",},{total:"--",}],
        ins:[{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},
          {total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},
          {total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},
          {total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},],
        weekmode:'yyyyyyy',timeRange:'', isA:false,isDu:false,
        whichDate:[],pagePos:[],perPage:[],chartEndPage:{show:false},
        hours:['00:00','01:00','02:00','03:00','04:00','05:00','06:00','07:00','08:00','09:00','10:00',
          '11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00'],

        statics:{},devices:['--','--','--'],hb1c:['--'],isEn:false,
        styleText:'<style type="text/css" media="print">@page{size:landscape;margin:0;}</style>',
      }
    },
    computed: {
      DataS(){
        return this.$store.state.DataS;
      },
      DataSG(){
        return  JSON.parse(sessionStorage.getItem('olDataSG'));
      },
    },
    methods:{
      getLogDate(st,et) {
        let count =  (et-st)/(3600*24)+1;
        let day = [];
        et = new Date((et+3600*8)*1000).toUTCString();
        for(let i=0;i<count;i++){
          let time = new Date( (st+3600*24*i+3600*8)*1000 ).toUTCString();
          let sp1 = time.split(',');
          let sp2 = sp1[1].split(' ');
          day[i] = sp2[2]+' '+sp2[1]+', '+sp2[3]+' '+sp1[0];
        }
        this.whichDate = day;
      },
      initTable(){
        const wrap = document.getElementById('table-wrapper');
        const wraps=document.getElementsByClassName('table-wrapper');
        console.log("wraps:", wraps);
        //return ;
        for (let w=0; w<wraps.length; w++) {
          let wrap = wraps[w];
          const tables = wrap.getElementsByTagName('table')[1];
          for(let i=0;i<tables.length;i++){
            const tr = tables[i].getElementsByTagName('tr');
            for(let j=0;j<tr.length;j++){
              const td = tr[j].getElementsByTagName('td');
              for(let k=3;k<td.length-1;k++){
                td[k].innerHTML ='';
                td[k].style.backgroundColor ='#fff';
              }
            }
          }
        }
      },
      makeNoMeal(){
        let noMeal = this.noMeal,mt = this.mt;
        for(let i=0;i<noMeal.length;i++){
          for(let j=0;j<3;j++){
            if(noMeal[i][j]===0){
              let id = i;
              const table1 = document.getElementById(id);
              const tr= table1.getElementsByTagName('tr')[1];
              const td = tr.getElementsByTagName('td')[2+mt[j][0]];
              const img = document.createElement('img');
              img.src = '/static/Lgb Icon/Missed Meal.png';
              img.className = 'insertImg';
              td.appendChild(img);
            }
          }
        }
        let mt1 = this.mt1;
        for(let i=0;i<3;i++) {
          const obj = document.getElementById('m'+i);
          obj.style.left =  parseFloat(mt1[i][0]) / 24 * 100  + '%';
          obj.style.width = (parseFloat(mt1[i][1]) - parseFloat(mt1[i][0])) * 36 + 'px';
        }
      },
      getLgbReportInfo(report_data) {
        let data =  report_data;
        data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
        this.statics = data;
        this.devices = (data.devices)?data.devices:this.devices;
        if ('EasyPatch'==this.devices[0]) {
          document.getElementById('reportPdmTitle').innerHTML='APP';
        }
        this.hb1c = (data.hba1c)?data.hba1c:this.hb1c;
      },
      /*
      getStatics(param){
        this.$http.get('api/v2.1/report/'+this.uid+'/data/lgb',{params:{param}}).then(function (res) {
          let err =res.body.error;
          if(err === 0){
            let data =  res.data.data;
            data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
            this.statics = data;
            this.devices = (data.devices)?data.devices:this.devices;
            this.hb1c = (data.hba1c)?data.hba1c:this.hb1c;
          }
        },function(err){
          let tip =  this.$t('tryAgain');
          this.$message.error(tip);
        })
      },*/
      getTs(st,et){
        let ts =[],days =(et-st)/86400+1,time=0,sp1=0,k=0;
        let No = auth.chekcNoDate(this.weekmode);
        this.whichDate = [];
        for(let i=0;i<days;i++){
          let day = new Date((st+i*86400)*1000).getDay();
          if(No.indexOf(day)===-1){
            ts[k] = [];
            ts[k][0] = st+i*86400;
            ts[k][1] = st+(i+1)*86400;
            time = new Date(ts[k][0]*1000).toString();
            sp1 = time.split(' ');
            if(this.isEn){
              this.whichDate[k] = sp1[2]+' '+this.$t(sp1[1])+', '+sp1[3]+' '+this.$t(sp1[0]);
            }else{
              let m = new Date(ts[k][0]*1000).getMonth()+1;
              m=(m<10)? '0'+m:m;
              this.whichDate[k] = sp1[3]+'-'+m+'-'+sp1[2]+' '+this.$t(sp1[0]);
            }
            k++;
          }
        }
        //
        let page_index=0;
        let PER_PAGE1=6;
        let PER_PAGE2=8;
        //let PER_PAGE=100;   // equivalent to previous
        while (page_index < this.whichDate.length) {
          //let page_date=whichDate.slice(page_index, page_index+PER_PAGE);
          //whichDatePage.push(page_date, page_index)
          this.pagePos.push(page_index);
          if (1==this.pagePos.length) {
            page_index += PER_PAGE1;
            this.perPage.push(PER_PAGE1);
          } else {
            page_index += PER_PAGE2;
            this.perPage.push(PER_PAGE2);
          }
        }
        let chartNum=this.whichDate.length;
        if (chartNum==14) {
          this.chartEndPage.show=true;
          this.long=true;
        }

        console.log('pagePos:', this.pagePos);
        //
        return ts;
      },
      makebg1(val,high,low){
        for(let i=0;i<val.length;i++){
          if(val[i].length>0){
            let id = i;
            const table1 = document.getElementById(id);
            const tr= table1.getElementsByTagName('tr')[0];
            for(let j=0;j<val[i].length;j++){
              if(val[i][j].length>0){
                const td = tr.getElementsByTagName('td')[3+j];
                if(val[i][j].length===2){
                  let div1 =document.createElement('div');
                  let div2 =document.createElement('div');
                  div2.style.float ='left';
                  div2.style.marginLeft ='3px';
                  div2.innerHTML =val[i][j][0];
                  let div3 =document.createElement('div');
                  div3.style.float ='left';
                  div3.style.width ='6px';
                  div3.style.height ='6px';
                  div3.style.borderRadius ='3px';
                  div3.style.backgroundColor ='#0f0f0f';
                  div1.appendChild(div2);
                  div1.appendChild(div3);
                  td.appendChild(div1);
                }else{
                  td.innerHTML = val[i][j][0];
                }
                if(val[i][j][0]>high){
                  td.style.backgroundColor ='#ffd125';
                }
                else if(val[i][j][0]<low){
                  td.style.backgroundColor ='#ff3d3d';
                }else{
                    td.style.backgroundColor ='#c6deb5';
                  }
              }
            }
          }
        }
      },
      makecarb(val){
        for(let i=0;i<val.length;i++){
          if(val[i].length>0){
            const table1 = document.getElementById(i);
            const tr= table1.getElementsByTagName('tr')[1];
            for(let j=0;j<val[i].length;j++){
              if(val[i][j]!==0){
                const td = tr.getElementsByTagName('td')[j+2];
                td.innerHTML = val[i][j];
              }
            }
          }
        }
        this.pringtPre =true
      },
      makeOth1(val,flag){
        for(let i=0;i<val.length;i++){
          const table1 = document.getElementById(i);
          let k =2;
          if(flag===4||flag===5||7===flag||8===flag||9===flag||10===flag||11===flag) {
            k = 3
          }
          const tr= table1.getElementsByTagName('tr')[k];
          for(let j=0;j<val[i].length;j++){
            if(val[i][j]===1){
              const td = tr.getElementsByTagName('td')[2+j];
              const img = document.createElement('img');
              img.style.height = '10px';
              img.style.width = '10px';
              if(flag===0){
                img.src = '/static/Lgb Icon/Auto Suspend.png';
              }
              if(flag===1){
                img.src = '/static/Lgb Icon/Manual Suspend.png';
              }
              if(flag===2){
                img.src = '/static/Lgb Icon/Stop Patch .png';
              }
              if(flag===3){
                img.src = '/static/Lgb Icon/New Patch .png';
              }
              if(flag===4){
                img.src = '/static/Lgb Icon/Exercise.png';
              }
              if(flag===5){
                img.src = '/static/Lgb Icon/Others.png';
              }
              if(flag===6){
                img.src = '/static/Lgb Icon/temp basal.png';
              }
              if (7===flag) {
                img.src = '/static/legend/automode/早餐.png';
                img.style.height = '15px';
                img.style.width = '22px';
              } else if(flag===8){
                img.src = '/static/legend/automode/中餐.png';
                img.style.height = '15px';
                img.style.width = '22px';
              } else if(flag===9){
                img.src = '/static/legend/automode/晚餐.png';
                img.style.height = '15px';
                img.style.width = '22px';
              } else if(flag===10){
                img.src = '/static/legend/automode/零食.png';
                img.style.height = '15px';
                img.style.width = '22px';
              } else if(flag===11){
                img.src = '/static/legend/automode/运动[30059].png';
                img.style.height = '15px';
                img.style.width = '22px';
              } else if(flag===12){
                img.src = '/static/legend/automode/进入自动模式.png';
                img.style.height = '15px';
                img.style.width = '15px';
              } else if(flag===13){
                img.src = '/static/legend/automode/退出自动模式.png';
                img.style.height = '15px';
                img.style.width = '15px';
              }
              img.style.marginRight = '2px';
              img.style.marginLeft = '2px';
              img.style.float = 'left';
              td.appendChild(img);
            }
          }
        }
      },
      makeBolus(val, flag){
        for(let i=0;i<val.length;i++) {
          let leng =  val[i].length;
          const table1 = document.getElementById(i);
          const tr= table1.getElementsByTagName('tr')[2];
          for (let k = 0; k <leng; k++) {
            if(val[i][k]!==0){
              const td = tr.getElementsByTagName('td')[k+2];
              if (flag[i][k]) {  // 带框
                let div3 =document.createElement('div');
                div3.style.float ='left';
                div3.style.width ='24px';
                div3.style.height ='16px';
                div3.style.borderRadius ='4px';
                div3.style.paddingTop ='1px';
                div3.style.border ='1px solid #222';
                div3.innerHTML = val[i][k].toFixed(2);
                td.appendChild(div3);
              } else {
                td.innerHTML = val[i][k].toFixed(2);
              }
            }
          }
        }
      },
      makeBolus2(val){
        for(let i=0;i<val.length;i++) {
          let leng =  val[i].length;
          if(leng>0){
            const table1 = document.getElementById(i);
            const tr= table1.getElementsByTagName('tr')[2];
            for (let k = 0; k <leng; k++) {
              if(val[i][k].length>0){
                const td = tr.getElementsByTagName('td')[val[i][k][0]+2];

                let div3 =document.createElement('div');
                div3.style.float ='left';
                div3.style.width ='32px';
                div3.style.height ='18px';
                div3.style.borderRadius ='4px';
                div3.style.paddingTop ='2px';
                div3.style.border ='1px solid #222';
                div3.innerHTML = val[i][k][1].toFixed(2);

                td.appendChild(div3);
                //td.innerHTML = val[i][k][1].toFixed(1);
              }
            }
          }
        }
      },
      makeNoPump(val){
        //console.log(val);
        for(let i=0;i<val.length;i++) {
          if(val[i]===1){
            const table = document.getElementById(i);
            const tr = table.getElementsByTagName('tr')[2];
            const td = tr.getElementsByTagName('td')[1];
            td.style.backgroundColor = '#ccc';
          }
        }
      },
      printPdf(){
        if(this.pringtPre === false)
        {
          this.$message({
            type: 'info',
            message: '数据加载中，请稍候再打印'
          });
        }else{
          auth.print_page();
        }
      },
    },
    mounted: function () {
      self.document.title = this.$t('logRe');
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isDe = (lang==='de')?true:false;
      this.isIt = (lang==='it')?true:false;
      this.isPo = (lang==='po')?true:false;
      this.isDu = (lang==='du')?true:false;
      this.isFr = (lang==='fr')?true:false;
      this.isSw = (lang==='sw')?true:false;
      this.isCz = (lang==='cz')?true:false;
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      this.et= parseInt(sessionStorage.getItem('qet5'));
      this.st= parseInt(sessionStorage.getItem('qst5'));
      this.timeRange = format.formatterDate2(this.st)+' - '+format.formatterDate2(this.et);
      this.weekmode = sessionStorage.getItem('qweekMode');
      this.getLogDate(this.st,this.et);
      this.ts = this.getTs(this.st,this.et);
      let param = {
        ts:this.ts,
        tz:parseInt(sessionStorage.getItem('tz')),
        weekmode:this.weekmode,
        gu:(this.isMg)?'mg/dL':'mmol/L',
      };
      param = B64.base64encode(JSON.stringify(param));
      auth.getLgb1(this,this.uid,param);
      //this.getStatics(param);
      let first = parseInt(sessionStorage.getItem('qFirst5'));
      if(first===1){
        auth.checkPrint(this,6,5);
      }
    },
  }
</script>


<style scoped meadia="print">
  /*@page{
    *size:auto;
    size:landscape;
    margin: 0;
  }*/
  .background{
    padding-top: 5mm;
    width: 100%;
    *min-height: 317mm;
    background: #ccc;
  }
  .long{
    *height:600mm;
  }
  .background .noPrint{
    float: left;
    border-radius:100px;
    background: #fff;
    border: 1px solid #a3a3a3;
    outline: none;
    margin-top:4px;
    width:90px;
    height:26px;
    line-height: 28px;
    cursor: pointer;
    margin-left:-140px;
    font-size: 13px;
    text-align: center;
  }
  @media print {
    .background .noPrint{
      display: none;
    }
  }
  .chart-container {
    width: 297mm;
    *min-height: 317mm;
    font-family: SFUIText-Regular;
    font-size: 13px;
    color: #282828;
    letter-spacing: -0.34px;
    background: #fff;
    margin: 0 auto;
    padding-left: 20px;
    padding-right: 20px;
  }
  .long1{
    *height:600mm;
  }
  @media screen and (max-width: 1450px){
    .background .noPrint{
      position: absolute;
      left: 20%;
      top: -1px;
    }
    .chart-container{
      margin-top: 20px;
    }
  }
  .Hcp-main-header {
    width: 97%;
    height: 40px;
    margin: 0 auto;
    font-family: SFUIText-Regular;
    font-size: 12px;
    color: #282828;
    padding-top: 10px;
  }
  .main-header-left {
    float: left;
  }
  .main-header-left img {
    height: 45px;
    width: 100px;
  }
  .main-header-right {
    float: right;
    text-align: right;
    padding-top: 10px;
    margin-right: 15px;
  }
  .main-header-right p {
    font-size: 13px;
    margin-bottom: 5px;
    letter-spacing: -0.29px;
    font-family: SFUIText-Regular;
    color: #282828;
  }
  .status-table1 {
    width: 94%;
    margin: 20px auto 16px;
    border: 1px solid #747474;
    font-family: SFUIText-Regular;
    border-collapse: collapse;
    text-align: left;
    table-layout: fixed;
  }
  .status-table1 td {
    padding-left: 10px;
    height: 15px;
  }
  .status-table1 .td1 {
    width: 14%;
  }
  .zh1 .td1 {
    width: 12%;
  }
  .status-table1 .td2 {
    border-bottom: 1px solid rgba(116, 116, 116, 0.34);
    border-right: 1px solid rgba(116, 116, 116, 0.34);
  }
  .status-table1 .td3 {
    border-bottom: 1px solid rgba(116, 116, 116, 0.34);
  }
  .status-table1 .td4 {
    border-right: 1px solid rgba(116, 116, 116, 0.34);
  }
  .small-hr {
    width: 94%;
    margin: 10px auto 16px;
    border-top: 1px solid #3b3b3b;
  }

  .chart-container .tip {
    width:863px;
    height:19px;
    margin-left:225px;
    margin-bottom: 1px;
    text-align: center;
    position: relative;
  }
  .tip span {
    font-family: SFUIText-Regular;
    font-size: 12px;
    color: #282828;
    background: #9cd4ff;
    display: inline-block;
    border-radius: 4px 4px 0 0;
    height: 19px;
    line-height: 19px;
    width: 40px;
    text-align: center;
    position: absolute;
    top:0;
    left:0;
  }
  .po6 span{
    overflow: hidden;
  }
  .fr6 span{
    white-space: nowrap;
  }
  .main-wrapper {
    width: 94%;
    margin: 0 auto;
  }
  .chart-container .table {
    width: 100%;
    margin: 0 auto;
    border-collapse: collapse;
    text-align: center;
    font-family:SFUIText-Regular;
    font-size: 12px;
    color: #282828;
    letter-spacing: -0.29px;
    table-layout: fixed;
  }
  .content td {
    border: 1px solid #d3d3d3;
    height: 18px;
    font-size: 12px;
  }
  .po4 td{
    word-break: break-all;
    word-wrap: break-word;
  }
  .content .spe {
    border-bottom: 0.5px dashed #d3d3d3;
    border-top: 0.5px dashed #d3d3d3;
  }
  .content .spe6 {
    border-top: 0.5px dashed #d3d3d3;
  }
  .content .spe1 {
    border-bottom: 0.5px dashed #d3d3d3;
  }
  .content .spe2 {
    border-bottom: none;
  }
  .content .spe3 {
    border-bottom: none;
    border-top: none;
  }
  .content .spe4, .content .spe5 {
    border-top: none;
  }
  .content .spe7 {
    border-bottom: 0.5px solid #d3d3d3;
    border-top: 0.5px solid #d3d3d3;
    border-left: none;
    border-right: none;
    font-size: 12px;
  }
  .content .spe10{
    border-left: none;
    font-size: 12px;
  }
  .legend-group {
    width: 94%;
    margin: 15px auto;
    font-family: SFUIText-Regular;
    font-size: 14px;
    color: #282828;
    letter-spacing: -0.39px;
  }
  .legend {
    float: left;
    margin-bottom: 12px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    margin-right: 60px;
  }
  .legend img {
    margin-right: 5px;
  }
  .img-spe {
    margin-bottom: -4px;
  }
  .img-spe1 {
    margin-bottom: 3px;
  }
  .img-spe2 {
    margin-bottom: -4px;
    width: 25px;
    height: 18px;
  }
  .legend-spe1 {
    margin-right: 40px;
  }
  .legend-spe2 {
    margin-right: 88px;
  }
  .legend-spe3 {
    margin-right: 103px;
  }
  .legend-spe5 {
    margin-right: 105px;
  }
  .legend-spe6 {
    margin-right: 120px;
  }
  .legend-spe7 {
    margin-right: 40px;
  }
  .legend-spe4 {
    margin-right: 100px;
  }
  .zh8 .legend {
    margin-right: 85px;
  }
  .de8 .legend {
    margin-right: 50px;
  }
  .de8 .de9 {
    margin-right: 60px;
  }
  .zh8 .zh9 {
    margin-right: 0;
  }
  .zh8 .zh10 {
    margin-right: 70px;
  }
  .zh8 .zh11 {
    margin-right: 115px;
  }
  .zh8 .zh12 {
    margin-right: 128px;
  }
  .zh8 .zh13 {
    margin-right: 117px;
  }
  .it8 .legend {
    margin-right: 40px;
  }
  .it8 .it10 {
    margin-right: 48px;
  }
  .it8 .it11 {
    margin-right: 102px;
  }
  .it8 .it12 {
    margin-right: 146px;
  }
  .it8 .it13 {
    margin-right: 90px;
  }
  .po8 .legend {
    margin-right: 48px;
  }
  .po8 .po10 {
    margin-right: 63px;
  }
  .po8 .po11{
    margin-right: 95px;
  }
  .po8 .po12{
    margin-right: 111px;
  }
  .po8 .po13{
    margin-right: 124px;
  }
  .po8 .po14{
    margin-right: 88px;
  }
  .du8 .legend {
    margin-right: 35px;
  }
  .du8 .legend-spe1 {
    margin-right:0;
  }
  .du8 .du10{
    margin-right:24px;
  }
  .du8 .du11{
    margin-right:84px;
  }
  .du8 .du12{
    margin-right:80px;
  }
  .du8 .du13{
    margin-right:148px;
  }
  .du8 .du14{
    margin-right:98px;
  }

  .fr8 .legend {
    margin-right: 40px;
  }
  .fr8 .legend-spe1 {
    margin-right:0;
  }
  .fr8 .legend-spe2{
    margin-right:38px;
  }
  .fr8 .legend-spe3{
    margin-right:82px;
  }
  .fr8 .legend-spe5{
    margin-right:76px;
  }
  .fr8 .legend-spe6{
    margin-right:126px;
  }
  .fr8 .legend-spe4{
    margin-right:58px;
  }
  .sw8 .legend-spe2{
    margin-right:90px;
  }
  .sw8 .legend-spe3{
    margin-right:120px;
  }
  .sw8 .legend-spe5{
    margin-right:120px;
  }
  .legend-group .cz10{
    margin-right:52px;
  }
  .legend-group .cz11{
    margin-right:84px;
  }
  .legend-group .cz12{
    margin-right:100px;
  }
  .legend-group .cz13{
    margin-right:111px;
  }
  .page-seperator {
    *height:25mm;
    page-break-before: always;
  }
  .page-starter{
    height:10mm;
  }
  .page-end {
    clear:both;
    height:10mm;
  }
</style>



// WEBPACK FOOTER //
// quickPrint5.vue?7a255894